// components/EnquiryCartIcon.js
import React from "react";

const EnquiryCartIcon = ({ width = 24, height = 24, fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    aria-hidden="true"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
             10-4.48 10-10S17.52 2 12 2zm0 
             17c-.55 0-1-.45-1-1s.45-1 1-1
             1 .45 1 1-.45 1-1 1zm1.07-7.75l-.9.92C11.45 
             12.9 11.25 13.5 11.25 14h-1.5v-.25c0-.83.34-1.63.93-2.21l1.24-1.26a1.49 
             1.49 0 10-2.12-2.1l-.14.15-1.06-1.06.14-.15a3 3 0 114.24 4.23z" />
  </svg>
);

export default EnquiryCartIcon;
